<div class="wrapper-modal sign-up-public-modal">
  <div class="wrapper-modal-content">
    <div class="back-btn-modal">
      <button class="custom-btn custom-btn--circle-outline" (click)="$event.stopPropagation(); closeModal.emit()">
        <img src="../../../../../assets/icons/outline/icon-close-modal.svg" alt="">
      </button>
    </div>
    <div class="modal-title">{{ 'NEW_TEXT_TRANSLATE.to_continue_using_thelysts_app_create_an_account_or_download_the_mobile_app' | translate }}</div>
    <div class="modal-buttons">
      <button class="custom-btn custom-btn--primary" (click)="$event.stopPropagation(); closeModal.emit()" [routerLink]="[PAGES_AND_PATHS.createAccount.pagePath]" ><span>{{ 'NEW_TEXT_TRANSLATE.sign_up_for_free' | translate }}</span></button>
    </div>
    <div class="text-label-modal">
      <p>or</p>
    </div>
    <div class="wrapper-btn-store-modal">
      <a href="https://apps.apple.com/us/app/thelysts/id6661027814">
        <img src="../../../../../assets/images/app-store-modal.png" alt="">
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.thelysts.app">
        <img src="../../../../../assets/images/play-store-modal.png" alt="">
      </a>
    </div>
    <div class="text-label-modal">
      <p>{{ 'CREATE_ACCOUNT.already_have_an_account' | translate }} <span (click)="$event.stopPropagation(); closeModal.emit()" [routerLink]="[PAGES_AND_PATHS.login.pagePath]">{{ 'GENERAL.login' | translate }}</span></p>
    </div>
  </div>
</div>
